import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { STORAGE_KEYS } from '@/lib/constants';
const OPPOSITION_KEY = 'apolo.opposition';
const ThemeContext = createContext(null);
function readStoredOpposition() {
    try {
        const raw = localStorage.getItem(OPPOSITION_KEY);
        if (raw === 'policia_local' || raw === 'policia_nacional' || raw === 'bomberos' || raw === 'none') {
            return raw;
        }
    }
    catch {
        // ignore
    }
    return 'none';
}
export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEYS.THEME);
            if (stored === 'dark' || stored === 'light')
                return stored;
        }
        catch {
            // ignore
        }
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    });
    const [opposition, setOppositionState] = useState(() => readStoredOpposition());
    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'dark')
            root.classList.add('dark');
        else
            root.classList.remove('dark');
        try {
            localStorage.setItem(STORAGE_KEYS.THEME, theme);
        }
        catch {
            // ignore
        }
    }, [theme]);
    useEffect(() => {
        const root = document.documentElement;
        if (opposition === 'none')
            root.removeAttribute('data-opposition');
        else
            root.setAttribute('data-opposition', opposition);
        try {
            localStorage.setItem(OPPOSITION_KEY, opposition);
        }
        catch {
            // ignore
        }
    }, [opposition]);
    function toggleTheme() {
        setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
    }
    function setOpposition(opp) {
        setOppositionState(opp);
    }
    return (_jsx(ThemeContext.Provider, { value: { theme, toggleTheme, opposition, setOpposition }, children: children }));
}
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx)
        throw new Error('useTheme must be used within ThemeProvider');
    return ctx;
}
//# sourceMappingURL=ThemeProvider.js.map